import { PasswordResetStepGuard } from 'presentation/app/contexts/PasswordResetStepGuard';
import React from 'react';

import { PageSetNewPassword } from './index';

export function ProtectedPageSetNewPassword() {
  return (
    <PasswordResetStepGuard step="password">
      <PageSetNewPassword />
    </PasswordResetStepGuard>
  );
}
